import { isArray, isMap, isNullOrUndefined as isNil, isObject, isSet, isString } from "@sindresorhus/is";

export {
  isArray,
  isBoolean,
  isFunction,
  isNull,
  isNullOrUndefined as isNil,
  isNumber,
  isObject,
  isString,
  isUndefined,
} from "@sindresorhus/is";
export { deepEqual as isEqualDeep, shallowEqual as isEqualShallow } from "fast-equals";

export function isEmpty(value: unknown) {
  if (isNil(value)) return true;
  if (isString(value) || isArray(value)) return value.length === 0;
  if (isMap(value) || isSet(value)) return value.size === 0;
  if (isObject(value)) return Object.keys(value).length === 0;

  return false;
}
